import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { InsightList } from '../../../../../components/design-system/analytics';
import { ReadingItem, toInsights } from '../reading';

/** The page's reading, first thing under the header — or a quiet placeholder while it loads. */
export function ReadingCard({
  items,
  loading,
  title,
  description,
  testId = 'viz-reading',
}: {
  items: ReadingItem[];
  loading?: boolean;
  title?: string;
  description?: string;
  testId?: string;
}) {
  const { t } = useTranslation();
  if (loading) {
    return (
      <Card className="gap-3" data-testid={`${testId}-loading`}>
        <CardHeader>
          <Skeleton className="h-4 w-40" />
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="h-4 w-2/3" />
        </CardContent>
      </Card>
    );
  }
  return (
    <InsightList
      title={title ?? t('VIZ_ANALYTICS.READING.TITLE')}
      description={description}
      insights={toInsights(items, t as any)}
      testId={testId}
    />
  );
}
